<template>
  <v-layout row justify-center>
    <v-dialog v-model="addProjectDialog" persistent max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline">
            <v-icon class="pr-2">add_circle</v-icon>
            Add a New Project
          </span>
        </v-card-title>
        <v-card-text>
          <v-form ref="add_project" data-vv-scope="add_project" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="form.name"
                  label="Project name*"
                  v-validate="'required|min:2'"
                  data-vv-name="add_project.name"
                  :error-messages="errors.collect('add_project.name')"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="form.domain"
                  label="Domain*"
                  v-validate="'required'"
                  data-vv-name="add_project.domain"
                  :error-messages="errors.collect('add_project.domain')"
                  hint="www.example.com or example.com"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="form.subdomains"
                  label="Subdomains"
                  hint="www.sub1.example.com, sub2.example.com"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-checkbox
                  v-model="form.verify_domain"
                  color="primary"
                  label="Verify domain"
                ></v-checkbox>
              </v-flex>
              <!-- <v-flex xs12>
                <v-textarea
                  v-model="form.keywords"
                  label="Keywords"
                  hint="Enter keywords one per line or separated by commas"
                  rows="4"
                ></v-textarea>
              </v-flex> -->
              <v-flex xs12>
                <v-select
                  v-model="form.engine_id"
                  :items="selectEngine"
                  item-text="name"
                  item-value="id"
                  label="Search engine*"
                  v-validate="'required'"
                  data-vv-name="add_project.engine_id"
                  :error-messages="errors.collect('add_project.engine_id')"
                >
                  <template slot="item" slot-scope="data">
                    <v-icon class="pr-2 engine-flag-icon">{{ data.item.country_css }}</v-icon><v-icon class="pr-2 engine-device-icon">{{ data.item.device_css }}</v-icon>{{ data.item.name }}
                  </template>
                </v-select>
              </v-flex>
            </v-layout>
            </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
          <v-btn color="primary" flat @click="createProject()" :loading="loading" :disabled="loading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'AddProjectModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: ['addProjectDialog', 'loading'],
  data () {
    return {
      form: {
        name: '',
        domain: '',
        verify_domain: true,
        subdomains: '',
        // keywords: '',
        engine_id: ''
      },
      project: {
        name: '',
        domain: '',
        verify_domain: true,
        subdomains: [],
        // keywords: [],
        engine_id: ''
      },
      dictionary: {
        en: {
          custom: {
            'add_project.name': {
              required: 'Project name required',
              min: 'Required at least 2 symbols'
            },
            'add_project.domain': {
              required: 'Domain name required',
              min: 'Required at least 2 symbols'
            },
            'add_project.engine_id': {
              required: 'Enjine name required'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
  },
  computed: {
    selectEngine: function () {
      return this.$store.state.metadata.selectEngines
    }
  },
  methods: {
    createProject () {
      this.$validator.validateAll('add_project').then(res => {
        if (res) {
          this.$parent.$emit('loading', true)
          this.formToProject()

          this.$store.dispatch('CREATE_PROJECT', this.project).then(res => {
            this.$parent.$emit('loading', false)
            this.$parent.$emit('updateProjectsList')
            this.$store.dispatch('GET_USER_DATA')
            this.closeModal()
          }, err => {
            console.log('login error', err)
            this.$parent.$emit('loading', false)
            this.$toasted.show('CREATE_PROJECT ERROR: ' + this.$services.getApiError(err), { type: 'error' })
          })
        }
      })
    },
    closeModal () {
      this.$parent.$emit('addProjectDialog', false)
      this.clearForm()
      setTimeout(() => {
        this.$validator.errors.clear('add_project')
      }, 500)
    },
    formToProject () {
      this.project.name = this.form.name
      this.project.domain = this.form.domain
      this.project.verify_domain = this.form.verify_domain
      if (this.form.subdomains) {
        this.project.subdomains = this.form.subdomains.split(',').map((subdomain) => { return subdomain.trim() })
      }
      // this.project.keywords = this.keywordsToArray(this.form.keywords)
      this.project.engine_id = this.form.engine_id
    },
    keywordsToArray (strKeywords) {
      let arrKeywords = []

      // check if there are some lines
      var match = /\r|\n/.exec(strKeywords)

      if (match) {
        let arrLines = strKeywords.match(/[^\r\n]+/g)
        arrKeywords = arrLines.map((line) => {
          return line.split(',').map((keyword) => { return keyword.trim() })
        })
        // join arrays in array
        arrKeywords = [].concat.apply([], arrKeywords)
      } else {
        arrKeywords = strKeywords.split(',').map((keyword) => { return keyword.trim() })
      }

      // remove empty values
      arrKeywords = arrKeywords.filter((keyword) => {
        return keyword != null && keyword !== ''
      })

      return arrKeywords
    },
    clearForm () {
      this.form = {
        name: '',
        domain: '',
        verify_domain: true,
        subdomains: '',
        engine_id: ''
      }
      this.project = {
        name: '',
        domain: '',
        verify_domain: true,
        subdomains: [],
        engine_id: ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/add-project-modal/AddProjectModal.vue